// const domain =  'https://api-dev.easygo.com.ng:8443/';
// const domain =  'http://104.236.202.157:8080';
const domain = 'https://myapi.easygo.com.ng:8084/'
export default domain;
